"use client"

import { Button } from "@/components/ui/button"
import { Share } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { openModal } from "@/app/components/Modal"

/**
 * Simple share button for the action bar. Opens the share modal.
 * Includes a tooltip to improve user experience and accessibility.
 */
export function ShareButton() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          onClick={() => openModal("share")}
          aria-label="Share this post"
        >
          <Share className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Share this post with others</p>
      </TooltipContent>
    </Tooltip>
  )
}
